import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import {
  HeaderContainer,
  HeaderLeft,
  BackButton,
  HeaderContent,
  PageTitle,
  PageSubtitle,
  QuickStats,
  QuickStatItem,
  QuickStatLabel,
  QuickStatValue,
  QuickStatValueResolved,
  QuickStatValuePending,
  HeaderIcon,
} from "./styles";
import { DisputeData } from "./types";

interface DisputesHeaderProps {
  disputeData: DisputeData | null;
}

const DisputesHeader: React.FC<DisputesHeaderProps> = ({ disputeData }) => {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <HeaderLeft>
        <BackButton
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
          onClick={() => navigate(-1)}
          shape="circle"
          size="large"
          aria-label="Go Back"
        />
        <HeaderIcon iconColor="#E53E3E">
          <FontAwesomeIcon icon={faExclamationCircle} />
        </HeaderIcon>
        <HeaderContent>
          <PageTitle level={2}>Disputes Management</PageTitle>
          <PageSubtitle>Monitor and resolve customer disputes</PageSubtitle>
        </HeaderContent>
      </HeaderLeft>

      <QuickStats>
        <QuickStatItem>
          <QuickStatLabel>Total</QuickStatLabel>
          <QuickStatValue>{disputeData?.totalDisputes || 0}</QuickStatValue>
        </QuickStatItem>
        <QuickStatItem>
          <QuickStatLabel>Resolved</QuickStatLabel>
          <QuickStatValueResolved>
            {disputeData?.resolvedDisputes || 0}
          </QuickStatValueResolved>
        </QuickStatItem>
        <QuickStatItem>
          <QuickStatLabel>Pending</QuickStatLabel>
          <QuickStatValuePending>
            {disputeData?.pendingDisputes || 0}
          </QuickStatValuePending>
        </QuickStatItem>
      </QuickStats>
    </HeaderContainer>
  );
};

export default DisputesHeader;
